export default "__VITE_PUBLIC_ASSET__58bbb678__"